import(/* webpackMode: "eager", webpackExports: ["default","success","error"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/Home.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GalleriesSlider/GalleriesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenRegister"] */ "/vercel/path0/src/components/OpenRegister/OpenRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmmGallery"] */ "/vercel/path0/src/containers/Home/EmmGallery/EmmGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyUpdated"] */ "/vercel/path0/src/containers/Home/RecentlyUpdated/RecentlyUpdated.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/utils/styles.scss");
